/* Wuffy Lab - product page behaviour */
(function () {
  'use strict';
  if (window.__wlPdpInit) { return; }
  window.__wlPdpInit = true;

  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }

  ready(function () {

    /* ---------- Gallery ---------- */
    var gallery = document.querySelector('[data-wl-gallery]');
    if (gallery) {
      var slides = [].slice.call(gallery.querySelectorAll('[data-wl-slide]'));
      var thumbs = [].slice.call(gallery.querySelectorAll('[data-wl-thumb]'));
      var counter = gallery.querySelector('[data-wl-counter]');
      var idx = 0;
      var show = function (n) {
        if (!slides.length) return;
        idx = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.hidden = k !== idx; });
        thumbs.forEach(function (t, k) {
          var on = k === idx;
          t.setAttribute('aria-current', on ? 'true' : 'false');
          t.style.borderColor = on ? 'var(--wl-forest-800)' : 'var(--wl-border)';
          t.style.transform = on ? 'translateY(-2px)' : 'none';
        });
        if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
      };
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      var prev = gallery.querySelector('[data-wl-media-prev]');
      var next = gallery.querySelector('[data-wl-media-next]');
      if (prev) prev.addEventListener('click', function () { show(idx - 1); });
      if (next) next.addEventListener('click', function () { show(idx + 1); });
      show(0);

      var modal = document.querySelector('[data-wl-modal]');
      if (modal) {
        var mImg = modal.querySelector('[data-wl-modal-img]');
        var openM = function () {
          var cur = slides[idx];
          var img = cur && cur.querySelector('img');
          if (mImg) { mImg.src = img ? img.getAttribute('src') : ''; mImg.alt = img ? img.getAttribute('alt') : ''; }
          modal.hidden = false; document.body.style.overflow = 'hidden';
        };
        var closeM = function () { modal.hidden = true; document.body.style.overflow = ''; };
        gallery.querySelectorAll('[data-wl-zoom]').forEach(function (b) { b.addEventListener('click', openM); });
        modal.querySelectorAll('[data-wl-modal-close]').forEach(function (b) { b.addEventListener('click', closeM); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeM(); });
      }
    }

    /* ---------- Variant picker + subscription / one-time (Wuffes-style) ---------- */
    var form = document.querySelector('[data-wl-product-form]');
    if (form) {
      var dataEl = document.querySelector('[data-wl-variants]');
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
      var lines = { title: '{format} · {days} jours', sub: 'Livré tous les {days} jours · sans engagement', once: 'Environ {days} jours d’autonomie' };
      try { var sl = document.querySelector('[data-wl-labels]'); if (sl) { var pl = JSON.parse(sl.textContent) || {}; Object.keys(pl).forEach(function (k) { if (pl[k]) lines[k] = pl[k]; }); } } catch (e) {}
      var labels = { once_note: '', sub_note: '', per_day: '/jour', currency: 'EUR', locale: 'fr' };
      try { var l2 = document.querySelector('[data-wl-labels-2]'); if (l2) labels = Object.assign(labels, JSON.parse(l2.textContent) || {}); } catch (e) {}
      labels.per_day = labels.per_day || '/jour'; labels.currency = labels.currency || 'EUR'; labels.locale = labels.locale || 'fr';

      var fmt;
      try {
        var nf = new Intl.NumberFormat(labels.locale, { style: 'currency', currency: labels.currency });
        fmt = function (cents) { return nf.format(cents / 100); };
      } catch (e) { fmt = function (cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }; }
      var pct = function (n) { var r = Math.round(n * 10) / 10; return String(r).replace('.', ',') + ' %'; };
      var tpl = function (str, map) { return String(str).replace(/\{(\w+)\}/g, function (m, k) { return map[k] !== undefined ? map[k] : m; }); };

      var idInput = form.querySelector('[data-wl-variant-id]');
      var planInput = form.querySelector('[data-wl-selling-plan]');
      var priceEl = document.querySelector('[data-wl-price]');
      var compareEl = document.querySelector('[data-wl-compare]');
      var saveEl = document.querySelector('[data-wl-save]');
      var modeNote = document.querySelector('[data-wl-mode-note]');
      var submitBtn = form.querySelector('[data-wl-submit]');
      var submitLabel = form.querySelector('[data-wl-submit-label]');
      var submitPrice = form.querySelector('[data-wl-submit-price]');
      var submitWas = form.querySelector('[data-wl-submit-was]');
      var soldLabel = submitBtn ? submitBtn.getAttribute('data-sold-label') : 'Rupture de stock';
      var addLabel = submitBtn ? submitBtn.getAttribute('data-add-label') : 'Ajouter au panier';
      var stickyPrice = document.querySelector('[data-wl-sticky-price]');
      var stickyWas = document.querySelector('[data-wl-sticky-was]');
      var toggle = form.querySelector('[data-wl-mode-toggle]');
      var perks = form.querySelector('[data-wl-sub-perks]');
      var planHint = form.querySelector('[data-wl-plan-hint]');
      var sizeBtns = [].slice.call(document.querySelectorAll('[data-wl-calc] [data-wl-size]'));
      var hasPlans = variants.some(function (v) { return v.sp && v.sp.length; });
      var mode = (form.getAttribute('data-wl-default-mode') === 'sub' && hasPlans) ? 'sub' : 'once';
      var DISCOUNTS = [10, 12.5, 15];

      var selected = function () {
        var out = [];
        form.querySelectorAll('[data-wl-opt]').forEach(function (g) {
          var checked = g.querySelector('input:checked');
          out[Number(g.getAttribute('data-wl-opt'))] = checked ? checked.value : null;
        });
        return out;
      };
      var match = function (opts) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var j = 0; j < opts.length; j++) { if (opts[j] !== null && opts[j] !== undefined && v.o[j] !== opts[j]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      };

      /* size (first option) -> index -> days per pot from the portion calculator blocks */
      var sizeValues = [].slice.call(form.querySelectorAll('[data-wl-opt="0"] input')).map(function (i) { return i.value; });
      var sizeIndex = function (value) { var k = sizeValues.indexOf(value); return k < 0 ? 0 : k; };
      var daysPerPot = function (sizeIdx) {
        var b = sizeBtns[Math.min(sizeIdx, sizeBtns.length - 1)];
        var m = b ? /(\d+)/.exec(b.getAttribute('data-dur') || '') : null;
        return m ? Number(m[1]) : 40;
      };
      /* pots from the second option value ("2 pots") or card position */
      var cureInput = function (value) { return form.querySelector('[data-wl-cure-card] input[value="' + String(value).replace(/"/g, '\\"') + '"]'); };
      var potsFor = function (value) {
        var el = cureInput(value);
        var n = el ? Number(el.getAttribute('data-wl-pots')) : 0;
        if (n > 0) return n;
        var card = el ? el.closest('[data-wl-cure-card]') : null;
        return card ? Number(card.getAttribute('data-wl-cure-idx')) + 1 : 1;
      };
      var planMeta = function (p) {
        var s = (p.n || '') + ' ' + (p.o || '');
        var w = /(\d+)\s*(week|semaine)/i.exec(s); var d = /(\d+(?:[.,]\d+)?)\s*%/.exec(s);
        return { weeks: w ? Number(w[1]) : 0, pct: d ? Number(d[1].replace(',', '.')) : 0 };
      };
      /* plan matching the delivery interval (days for this size × pots) and the pot-count discount */
      var planFor = function (v, pots, days) {
        if (mode !== 'sub' || !v.sp || !v.sp.length) return null;
        var weeks = Math.max(1, Math.round(days / 7));
        var want = DISCOUNTS[Math.min(pots, DISCOUNTS.length) - 1];
        var best = null, bestScore = Infinity;
        v.sp.forEach(function (p) {
          var m = planMeta(p);
          var score = Math.abs(m.weeks - weeks) + (Math.abs(m.pct - want) < 0.01 ? 0 : 1000);
          if (score < bestScore) { bestScore = score; best = p; }
        });
        return best;
      };
      var calcFor = function (v, cureVal) {
        var sizeIdx = sizeIndex(v.o[0]);
        var pots = potsFor(cureVal);
        var days = daysPerPot(sizeIdx) * pots;
        var plan = planFor(v, pots, days);
        var base = null; /* one-time price of 1 pot for this size × pots (Wuffes-style "save %") */
        var firstCure = form.querySelector('[data-wl-cure-card][data-wl-cure-idx="0"] input');
        if (firstCure) { var v1 = match([v.o[0], firstCure.value]); if (v1) base = v1.pc * pots; }
        var pc = plan ? plan.pc : v.pc;
        return { plan: plan, pc: pc, days: days, pots: pots, base: base, save: (base && base > pc) ? (1 - pc / base) * 100 : 0 };
      };

      var paint = function () {
        var opts = selected();
        var v = match(opts);
        if (!v) return;
        var cureVal = opts[1] !== undefined && opts[1] !== null ? opts[1] : '';
        var c = calcFor(v, cureVal);

        /* keep the portion calculator in sync with the chosen size */
        var sb = sizeBtns[Math.min(sizeIndex(v.o[0]), sizeBtns.length - 1)];
        if (sb && sb.getAttribute('aria-pressed') !== 'true') sb.click();

        if (idInput) idInput.value = v.id;
        if (planInput) {
          if (c.plan) { planInput.value = c.plan.id; planInput.disabled = false; }
          else { planInput.value = ''; planInput.disabled = true; }
        }
        if (priceEl) priceEl.innerHTML = fmt(c.pc);
        if (compareEl) { if (v.cc > c.pc) { compareEl.innerHTML = fmt(v.cc); compareEl.hidden = false; } else { compareEl.hidden = true; } }
        if (saveEl) {
          if (v.cc > c.pc) { saveEl.textContent = '-' + Math.round((1 - c.pc / v.cc) * 100) + ' %'; saveEl.hidden = false; }
          else { saveEl.hidden = true; }
        }
        if (modeNote) {
          var note = c.plan ? labels.sub_note : labels.once_note;
          modeNote.textContent = note || ''; modeNote.hidden = !note;
        }
        if (stickyPrice) stickyPrice.innerHTML = fmt(c.pc);
        if (stickyWas) { if (v.cc > c.pc) { stickyWas.innerHTML = fmt(v.cc); stickyWas.hidden = false; } else { stickyWas.hidden = true; } }
        if (submitBtn) {
          submitBtn.disabled = !v.a;
          submitBtn.style.opacity = v.a ? '1' : '.5';
          if (submitLabel) submitLabel.textContent = v.a ? addLabel : soldLabel;
          if (submitPrice) submitPrice.textContent = v.a ? '· ' + fmt(c.pc) : '';
          if (submitWas) { if (v.a && v.cc > c.pc) { submitWas.textContent = fmt(v.cc); submitWas.hidden = false; } else { submitWas.hidden = true; } }
        }
        if (toggle) {
          if (!v.sp || !v.sp.length) { toggle.hidden = true; }
          else if (mode === 'sub') {
            toggle.hidden = false;
            toggle.textContent = tpl(toggle.getAttribute('data-once-label') || 'Acheter une seule fois pour {price}', { price: fmt(v.pc) });
          } else {
            toggle.hidden = false;
            toggle.textContent = tpl(toggle.getAttribute('data-sub-label') || 'S’abonner et économiser {save}', { save: 'jusqu’à ' + pct(DISCOUNTS[DISCOUNTS.length - 1]) });
          }
        }
        if (perks) perks.hidden = !(mode === 'sub' && c.plan);
        if (planHint) planHint.hidden = mode === 'sub';

        /* per-choice details on the format cards */
        var fill = function (attr, cb) {
          form.querySelectorAll('[' + attr + ']').forEach(function (el) {
            var value = el.getAttribute(attr);
            var probe = opts.slice(); probe[Number(el.getAttribute(attr.replace('-for', '-idx')))] = value;
            var pv = match(probe);
            if (!pv) { el.hidden = true; return; }
            cb(el, pv, value, calcFor(pv, value));
          });
        };
        fill('data-wl-title-for', function (el, pv, value, k) { el.textContent = tpl(lines.title, { format: value, days: k.days, pots: k.pots }); el.hidden = false; });
        fill('data-wl-total-for', function (el, pv, value, k) { el.innerHTML = fmt(k.pc); el.hidden = false; });
        fill('data-wl-was-for', function (el, pv, value, k) {
          if (pv.cc > k.pc) { el.innerHTML = fmt(pv.cc); el.hidden = false; } else { el.hidden = true; }
        });
        fill('data-wl-day-for', function (el, pv, value, k) {
          if (k.days > 0) { el.textContent = '≈ ' + fmt(Math.round(k.pc / k.days)) + labels.per_day; el.hidden = false; } else { el.hidden = true; }
        });
        fill('data-wl-save-for', function (el, pv, value, k) {
          var sv = k.plan ? planMeta(k.plan).pct : k.save; /* subscription: the plan's own % (Wuffes-style); one-time: vs 1 pot × n */
          if (sv > 0.05) { el.textContent = el.getAttribute('data-wl-save-prefix') + ' ' + pct(sv); el.hidden = false; }
          else { el.hidden = true; }
        });
        fill('data-wl-sub-for', function (el, pv, value, k) {
          var map = { days: k.days, pots: k.pots, weeks: Math.round(k.days / 7) };
          if (k.plan) { el.textContent = tpl(lines.sub, map); el.hidden = false; }
          else if (lines.once) { el.textContent = tpl(lines.once, map); el.hidden = false; }
          else { el.hidden = true; }
        });
      };

      form.querySelectorAll('[data-wl-opt] input').forEach(function (input) {
        input.addEventListener('change', function () {
          var label = input.closest('label');
          var group = input.closest('[data-wl-opt]');
          if (group) {
            group.querySelectorAll('label').forEach(function (l) {
              var on = l.contains(l.querySelector('input:checked'));
              l.style.borderColor = on ? 'var(--wl-forest-800)' : 'var(--wl-border)';
              l.style.background = on ? 'var(--wl-cream)' : 'var(--wl-white)';
            });
          }
          if (label) { label.style.borderColor = 'var(--wl-forest-800)'; label.style.background = 'var(--wl-cream)'; }
          paint();
        });
      });
      if (toggle) toggle.addEventListener('click', function () { mode = mode === 'sub' ? 'once' : 'sub'; paint(); });
      /* default to the middle size (like Wuffes) unless a variant was given in the URL */
      if (!/[?&]variant=/.test(location.search) && sizeValues.length > 2) {
        var mid = form.querySelectorAll('[data-wl-opt="0"] input')[1];
        if (mid && !mid.checked) { mid.checked = true; mid.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      /* run after the calculator has initialised (it is defined below) */
      setTimeout(paint, 0);

      /* quantity */
      var qtyInput = form.querySelector('[data-wl-qty-input]');
      var qtyView = form.querySelector('[data-wl-qty-view]');
      form.querySelectorAll('[data-wl-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var d = b.getAttribute('data-wl-qty') === 'inc' ? 1 : -1;
          var n = Math.max(1, Number(qtyInput.value || 1) + d);
          qtyInput.value = n;
          if (qtyView) qtyView.textContent = n;
        });
      });
    }

    /* ---------- Portion calculator ---------- */
    var calc = document.querySelector('[data-wl-calc]');
    if (calc) {
      var out = {
        chews: calc.querySelector('[data-wl-calc-chews]'),
        dur: calc.querySelector('[data-wl-calc-dur]'),
        interval: calc.querySelector('[data-wl-calc-interval]')
      };
      var btns = [].slice.call(calc.querySelectorAll('[data-wl-size]'));
      var pickSize = function (b) {
        btns.forEach(function (x) {
          var on = x === b;
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
          x.style.borderColor = on ? 'var(--wl-forest-800)' : 'var(--wl-border)';
          x.style.background = on ? 'var(--wl-cream)' : 'var(--wl-white)';
        });
        if (out.chews) out.chews.textContent = b.getAttribute('data-chews') || '';
        if (out.dur) out.dur.textContent = b.getAttribute('data-dur') || '';
        if (out.interval) out.interval.textContent = b.getAttribute('data-interval') || '';
      };
      btns.forEach(function (b) { b.addEventListener('click', function () { pickSize(b); }); });
      if (btns.length) pickSize(btns[Math.min(1, btns.length - 1)]);
    }

    /* ---------- Tabs ---------- */
    document.querySelectorAll('[data-wl-tabs]').forEach(function (root) {
      var tabs = [].slice.call(root.querySelectorAll('[data-wl-tab]'));
      var panels = [].slice.call(root.querySelectorAll('[data-wl-panel]'));
      var pick = function (n) {
        tabs.forEach(function (t, k) {
          var on = k === n;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.style.background = on ? 'var(--wl-forest-800)' : 'transparent';
          t.style.color = on ? 'var(--wl-cream)' : 'var(--wl-forest-800)';
          t.style.borderColor = on ? 'var(--wl-forest-800)' : 'var(--wl-border)';
        });
        panels.forEach(function (p, k) { p.hidden = k !== n; });
      };
      tabs.forEach(function (t, k) { t.addEventListener('click', function () { pick(k); }); });
      pick(0);
    });

    /* ---------- Review filters ---------- */
    document.querySelectorAll('[data-wl-filters]').forEach(function (root) {
      var chips = [].slice.call(root.querySelectorAll('[data-wl-filter]'));
      var listId = root.getAttribute('data-wl-filters');
      var list = document.getElementById(listId);
      if (!list) return;
      var cards = [].slice.call(list.querySelectorAll('[data-wl-tags]'));
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          var val = c.getAttribute('data-wl-filter');
          chips.forEach(function (x) {
            var on = x === c;
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
            x.style.background = on ? 'var(--wl-forest-800)' : 'var(--wl-white)';
            x.style.color = on ? 'var(--wl-cream)' : 'var(--wl-forest-800)';
          });
          cards.forEach(function (card) {
            var tags = (card.getAttribute('data-wl-tags') || '').toLowerCase();
            card.hidden = val !== '*' && tags.indexOf(val.toLowerCase()) === -1;
          });
        });
      });
    });

    /* ---------- Sticky buy bar ---------- */
    var sticky = document.querySelector('[data-wl-pdp-sticky]');
    if (sticky) {
      var anchor = document.querySelector('[data-wl-cta-anchor]');
      sticky.hidden = true;
      if (anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { sticky.hidden = es[0].isIntersecting; }, {}).observe(anchor);
      }
      var close = sticky.querySelector('[data-wl-pdp-sticky-close]');
      if (close) close.addEventListener('click', function () { sticky.parentNode.removeChild(sticky); });
      var sbtn = sticky.querySelector('[data-wl-sticky-add]');
      if (sbtn) sbtn.addEventListener('click', function () {
        var f = document.querySelector('[data-wl-product-form]');
        if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
      });
    }
  });
})();
